import {
  useGridApiContext,
  useGridSelector,
  gridDensitySelector,
} from "@mui/x-data-grid-premium";
import { standardizeAndMagnifyEffectHtmlImages } from "./htmlColumn";

export const HtmlCell = ({ value }: { value: any }) => {
  const apiRef = useGridApiContext();
  const density = useGridSelector(apiRef, gridDensitySelector);
  return (
    <div
      onMouseDown={(e) => e.stopPropagation()}
      style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100%", width: "100%" }}
      dangerouslySetInnerHTML={{
        __html: standardizeAndMagnifyEffectHtmlImages(value, undefined, undefined, density),
      }}
    />
  );
};
